
import Banner1 from "./banner1";
import Banner2 from "./banner2";
import Banner3 from "./banner3";
export default function Banner({
    options,
    data
}) {
    
    const type = options.type; // 1 单图， 2 多图

    console.log("here type is------------", type)

    if(type === 1) {
        return (
            <Banner1 
                options={options}
                data={data}
            />
        )
    }

    if(type === 2) {
        return (
            <Banner2
                options={options}
                data={data}
            />
        )
    }

    if(type === 3) {
        return (
            <Banner3 
                options={options}
                data={data}
            />
        )
    }

    return <>
    </>
}